'use strict';

import { createHtmlElement } from '../../functions';
import { Buildings, isMobile, projectMode, settingsData } from '../../settings';
import {searchGetResults, showSearchResults, selectedBuildings, updateSearchResults} from './search';
import { BuildingSwitch } from '../building-switch/building_switch';
import { isOrbitControlsEnabled } from '../controls/orbitControls';
import { changeLangToCurrent, getCurrentLang } from '../language/langSwitcher';
import {bombButtonInitActionHandler} from "../controls/destroyBuilding";



export function createMultipleSearch () {
    if (Buildings.getBuildingsInfoLength() < 2) {
        Buildings.getBuildingsArray().forEach((building) => {
            if (Object.keys(building.info).length !== 0)
                selectedBuildings.add(building.name);
        });
        return;
    }


    const searchResultWrapper = document.querySelector('.search__result-wrapper');
    const mainContainer = createHtmlElement(searchResultWrapper,'','div',['multiple__search__container']);
    // const activeBuilding = Buildings.getActiveBuilding();

    Buildings.getBuildingsArray().forEach((building) =>{
        if (Object.keys(building.info).length === 0) return;

        let towerName;

        selectedBuildings.add(building.name);

        if (Array.isArray(building.info.towerName)){
            towerName = building.info.towerName.find(el => el.lang === getCurrentLang()).value;
        } else {
            towerName = building.info.towerName;
        }

       const searchResult = searchGetResults(0,building,false);
       const resultContainer = createHtmlElement(mainContainer,'','div',['multiple__result__container']);
       resultContainer.dataset.towerName = towerName;
       resultContainer.dataset.building = building.name;

       // if (building === activeBuilding)
        if (selectedBuildings.has(building.name))
           resultContainer.classList.add('active-multi-building');

       const iconBuilding = createHtmlElement(resultContainer,'','div',['icon-building']);
       const buildingNameWrap = createHtmlElement(resultContainer,'','div',['multiple__building-wrap']);
       // const buildingName = createHtmlElement(buildingNameWrap,`${changeLangToCurrent('building')} ${building.towerName.replace(/\D/g,'')}  (`,'span',['multiple__building-name']);
       const buildingName = createHtmlElement(buildingNameWrap,`${towerName}  (`,'span',['multiple__building-name']);
       const totalSearchNumber = createHtmlElement(buildingNameWrap, getAmountOfFoundFlats(searchResult, building),'span',['multiple__result__count']);
       const endBracket = createHtmlElement(buildingNameWrap, ')','span');
    });

    // setTimeout(()=> scrollToActiveMultiSearchButton(),200);

    mainContainer.addEventListener('click', multiSearchHandler);
}

export function updateMultiSearch () {
    // if (Buildings.getBuildingsInfoLength() < 2) return;

    Buildings.getBuildingsArray().forEach(building =>{

        let towerName;

        if (Array.isArray(building.info.towerName)){
            towerName = building.info.towerName.find(el => el.lang === getCurrentLang()).value;
        } else {
            towerName = building.info.towerName;
        }

        const searchResult = searchGetResults(0,building,false);
        const htmlElement = document.querySelector(`.multiple__result__container[data-tower-name="${towerName}"`);
        if (htmlElement){
            const count = htmlElement.querySelector('.multiple__result__count');
            count.textContent = getAmountOfFoundFlats(searchResult, building);

            // if (searchResult.length){
            //     htmlElement.classList.remove('no-found-apartments');
            // } else {
            //     htmlElement.classList.add('no-found-apartments');
            // }
        }
    });
}

function getAmountOfFoundFlats(searchResult, building) {
    let amount = 0;

    searchResult.forEach(element => {
        if (element.buildingEngineId === building.name) amount++;
    });

    return amount.toString();
}

async function multiSearchHandlerThrottling(e) {

    const currentTarget = e.target.closest('[data-tower-name]');
    currentTarget && toggleMultiSearchButton(currentTarget);
    updateMultiSearch();
    updateSearchResults();

    // let selectedSearchResults;
    //
    // if (e.target.classList.contains('multiple__search__container')){
    //     return;
    // } else if (!e.target.classList.contains('multiple__result__container')){
    //     selectedSearchResults = e.target.closest('.multiple__result__container');
    // } else {
    //     selectedSearchResults = e.target;
    // }
    //
    // const activeBtn = getActiveMultiSearchButton();
    // const buildingName = selectedSearchResults.getAttribute('data-building');
    //
    // if (activeBtn.dataset.building !== selectedSearchResults.dataset.building ){
    //     if (settingsData.buildingDestroyed) await projectMode.FloorPlan.exitFromMode();
    //     await projectMode.Cylinder.switchBuilding(buildingName);
    //     setActiveMultiSearchButton(buildingName);
    // }
}

function toggleMultiSearchButton(target) {
    const buildingName = target.getAttribute('data-building');
    if (selectedBuildings.has(buildingName)) {
        if (selectedBuildings.size <= 1) return;
        selectedBuildings.delete(buildingName);
        target.classList.toggle('active-multi-building');
    } else {
        selectedBuildings.add(buildingName);
        target.classList.toggle('active-multi-building');
    }
}

let clickTourTimer = null;
function multiSearchHandler (e) {
    if (!isOrbitControlsEnabled() && !projectMode.LiteMode.modeIs('picture')){
        return;
    }

    if (clickTourTimer !== null) {
        clearTimeout(clickTourTimer);
    }

    clickTourTimer = setTimeout(() => multiSearchHandlerThrottling(e), 300);
}

function getActiveMultiSearchButton () {
    return document.querySelector('.multiple__result__container.active-multi-building');
}

export function setActiveMultiSearchButton (buildingName) {
    if (Buildings.getBuildingsInfoLength() < 2){
        return;
    }

    let searchContainer;

    if (isMobile){
        searchContainer = document.querySelector('.search__container-bottom');
    } else {
        searchContainer = document.querySelector('.search__container-main');
    }
    if (!searchContainer){
        return;
    }

    const activeBtn = getActiveMultiSearchButton();
    const nextBtn = searchContainer.querySelector(`.multiple__result__container[data-building="${buildingName}"]`);

    activeBtn.classList.remove('active-multi-building');
    nextBtn.classList.add('active-multi-building');

    nextBtn.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
    });
}

export function scrollToActiveMultiSearchButton () {
    const activeBtn = getActiveMultiSearchButton();

    activeBtn.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
    });
}
